import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";

interface IOrderProductLine {
  PrimaryActionComponent: JSX.Element;
}

const OrderAdminHeader: React.ReactFCWithChildren<IOrderProductLine> = ({ PrimaryActionComponent }) => {
  return (
    <OrderAdminHeaderWrapper
      direction="vertical"
      valign="center"
    >
      <Grid.Box className="order-actions">
        {PrimaryActionComponent}
      </Grid.Box>
    </OrderAdminHeaderWrapper>
  );
};

const OrderAdminHeaderWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.md};
    margin-bottom: ${theme.spacing.margins.md};
  `};
`;

export default OrderAdminHeader;
